angular.module('rjmNg.controllers').controller('overdueBillingCtrl', [
  "$scope"
  "$location"
  "$routeParams"
  "$http"
  "$url"
  "app"
  "$clientAppUrl"
  (
    $scope
    $location
    $routeParams
    $http
    $url
    app
    $clientAppUrl
  ) ->

    if not $scope.hasMagentoSubscription
      $scope.billingUrl = $clientAppUrl("/settings/billing/")
    else
      $scope.billingUrl = "https://account.magento.com/mbi/subscription"

    $scope.settingsUrl = $clientAppUrl("/settings/personal/")

    $scope.logBillingModalDismissal = ->
      $http
        method: "POST"
        url: $url("/user/#{app.getUserId()}/userevent"),
        data:
          eventType: 3 #3 is DISMISSED_BILLING_WARNING event
          clientId: app.getClientId()

    $scope.isBillingUser = app.isBillingUser()

    $scope.billingContactName = app.getBillingContactName()

    $scope.billingContactEmail = app.getBillingContactEmail()
  ]
)
